/**
 * Model to handle timezone-list
 */
define('dataSource/userPreferences',['atn/atn', 'knockout', 'jquery', 'lodash'],
    function(atn, ko, $, _) {
        'use strict';
        /**
         * user preferences
         * @type {ko.observable}
         */
        var userPreferences = ko.observable(null);
        var allUserPreferences = ko.observable(null);
        var apiFailure = ko.observable();
        var ACTIVE_DASHBOARD = 'ACTIVE_DASHBOARD';
        var DEFAULT_DASHBOARD = 'dashboard0';

        //the below code clears the observables passed on logout.
        atn.dataCache.addRegistry([userPreferences, apiFailure]);

        return {
            userPreferences: userPreferences,
            allUserPreferences: allUserPreferences,
            getUserPreferences: getUserPreferences,
            updateUserPreferences: updateUserPreferences,
            apiFailure: apiFailure,
            ACTIVE_DASHBOARD: ACTIVE_DASHBOARD
        };
        /**
         * function to get user preferences
         * @param  {boolean} reload       
         * @return {jquery.promise}        promise for getting userPreferences
         */
        function getUserPreferences(reload) {
            if(reload  || !allUserPreferences()) {
                return fetchUserPreferences();
            }        
            userPreferences(getUserPreferenceOfActiveDashboard(allUserPreferences()[ACTIVE_DASHBOARD]));
            return atn.utils.dummySuccessDeferred();
         }
               
        /**
         * fetches the latest list of timezones into timezoneList
         * @return {promise} promise object for fetching timezoneList
         */
        function fetchUserPreferences() {

            var deferred = $.Deferred();
            var ajaxPromise;
            apiFailure(false);

            ajaxPromise = $.ajax({
                url: atn.config.api.userPreferences,
                type: 'GET',
                contentType: 'application/json'
            });

            ajaxPromise.done(function(response){
                allUserPreferences(response);
                userPreferences(getUserPreferenceOfActiveDashboard(allUserPreferences()[ACTIVE_DASHBOARD]));
                deferred.resolve(response);
            });

            ajaxPromise.fail(function(xhr){
                deferred.reject(xhr);
                apiFailure(true);
            });

            return deferred.promise();
        }

        function updateUserPreferences(prefs){
            var deferred = $.Deferred(),
                ajaxPromise,
                requestData = {};

            apiFailure(false);
           
            requestData.value = prefs.valueString;

            ajaxPromise = $.ajax({
                url: atn.config.api.userPreferences + '/' + prefs.keyString,
                data: JSON.stringify(requestData),
                dataType: 'json',
                type: 'PUT',
                contentType: 'application/json'
            });

            ajaxPromise.done(function(response){
                deferred.resolve(response);
            });

            ajaxPromise.fail(function(xhr){
                deferred.reject(xhr);
                apiFailure(true);
            });

            return deferred.promise();
        }
       
        function getUserPreferenceOfActiveDashboard(activeDashboardId){
            if(!activeDashboardId) {
                activeDashboardId = DEFAULT_DASHBOARD;
            }
            var retObj = {},
                chartId,
                valObj, dashboardId;
            _.forEach(allUserPreferences(), function(val, key, obj){
                chartId = key.split('.')[1];
                try{
                    valObj = JSON.parse(val);
                    dashboardId = key.split('.')[0];

                    if(dashboardId == activeDashboardId && chartId) {
                        if(!retObj[chartId]){
                            retObj[chartId] = {};   
                        }
                        retObj[chartId].filter = valObj ? valObj.filter : null;                   
                    }   
                }catch(e){}
            });
            return retObj;
        }

    });
